import * as actionTypes from '../../actionTypes';
export const loginFormChange = ({index,event}) => {
    return dispatch => {
        dispatch({
            type:actionTypes.LOGIN_FORM_CHANGE,
            index,
            event
        });
    };
};